import { makeStyles } from '@material-ui/core';
import { rem } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  container: {
    padding: '0 0 10px 10px',
    backgroundColor: themeColor.verylightgrey,
  },
  currency: {
    fontWeight: 500,
    fontSize: '1.5rem',
    color: themeColor.defaultTextColor,
    margin: '5px 0px',
  },
  closeButton: {
    fontSize: rem(1),
    color: themeColor.defaultTextColor,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
  },
  rightButton: {
    marginRight: '10px',
    fontSize: rem(1),
    '&:hover': {
      boxShadow: 'none',
    },
  },
  flexDisplay: {
    display: 'flex',
  },
  amountAlignment: {
    textAlign: 'end',
    marginRight: '1vw',
  },
  descriptionAlignment: {
    alignSelf: 'center',
    textAlign: 'start',
    marginLeft: '1vw',
  },
}));
